export const calendarDayOfWeek_Wednesday = "UlgG3d";
export default {calendarDayOfWeek_Wednesday};